<template>
  <v-container>
    <v-row align="center" style="margin-top:3rem">
      <v-col cols="12" class="text-center">
        <h3 v-html="title"></h3>
        <p>{{ text }}</p>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
        v-for="(item, index) in list"
        :key="index"
        data-aos="zoom-in"
        :data-aos-delay="$vuetify.breakpoint.mdAndUp ? 300 * (index % 2) : 0"
      >
        <v-card>
          <v-row align="center">
            <v-col md="auto" class="pa-5">
              <v-img
                contain
                height="100"
                :src="require(`@/assets/${item.img}`)"
              ></v-img>
            </v-col>
            <v-col>
              <h3 :style="`color:${color}`">{{ item.title }}</h3>
              <p>{{ item.text }}</p>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    title: String,
    text: String,
    list: Array,
    color: String
  }
};
</script>
